import { useEffect, useState } from 'react';
import React from 'react';
import './donde.css';
import { useTranslation } from "react-i18next";

import librito from '../../../assets/imgs/libro_bitcoin/Rectangle_libro2.png';
import logo1 from '../../../assets/imgs/libro_bitcoin/LOGO_EDITORIAL_2.png';
import logo2 from '../../../assets/imgs/libro_bitcoin/Assets_Elektra-blanco.svg';

import librito2 from '../../../assets/imgs/libro_bitcoin/Bitcoin-imgbook2.png';

const Donde = () => {
    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("libroBitcoin");
    const [isFromMexico, setIsFromMexico] = useState(null);

    const compraInternacional = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Internacional',
            value: 1
        });
    };

    const compraMexico = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Mexico',
            value: 1
        });
    };

    const IMGcompraInternacional = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Internacional',
            value: 1
        })
        window.open('https://thesaifhouse.com/');
    };

    const IMGcompraInternacionalEbook = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Internacional',
            value: 1
        })
        window.open('https://academy.saifedean.com/product/the-bitcoin-enlightenment-digital-book/?v=3d26b0b17065');
    };

    const IMGcompraMexico = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Mexico',
            value: 1
        })
        window.open('https://www.elektra.mx/the-bitcoin-enlightenment/p');
    };

    useEffect(() => {
        fetch('https://ipapi.co/json/')
            .then(res => res.json())
            .then(data => {
                console.log("Mexico");
                setIsFromMexico(data.country_code === 'MX');
            })
            .catch(err => {
                console.log("Internacional");
                console.error('Error detecting country:', err);
            });
    }, []);

    return (
        <>
            <div class="landing_bitcoin_donde">
                <div class="landing_bitcoin_donde_adquierelo">
                    <div class="landing_bitcoin_donde_adquierelo_content">
                        <div class="adquierelo_content_1">
                            <h3>{(t('donde.titulo'))}</h3>
                            <div class="adquierelo_content_3 adquierelo_content_4">
                                <img src={librito2}></img>
                            </div>
                            {isFromMexico ? (
                                <>
                                    <div className='div-opciones-buy-b'>
                                        <div className='div-2'>
                                            <img onClick={IMGcompraMexico} src={logo2}></img>
                                            <a onClick={compraMexico} target='_blank' href='https://www.elektra.mx/the-bitcoin-enlightenment/p'>{(t('donde.btn1'))}</a>
                                        </div>
                                        <div className='div-1'>
                                            <img onClick={IMGcompraInternacionalEbook} src={logo1}></img>
                                            <a onClick={compraInternacional} target='_blank' href='https://academy.saifedean.com/product/the-bitcoin-enlightenment-digital-book/?v=3d26b0b17065'>{(t('header.btn3'))}</a>
                                            {t('donde.btnaudio') === 'EN' && (
                                                <a onClick={compraInternacional} className='a-bit-opt-small' target='_blank' href='https://academy.saifedean.com/product/the-bitcoin-enlightenment-audiobook/?v=0b3b97fa6688'>
                                                    {/* Puedes usar una key de traducción, texto fijo o uno nuevo */}
                                                    Buy Audiobook
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>

                                    <div className='div-opciones-buy-b'>
                                        <div className='div-2'>
                                            <img onClick={IMGcompraMexico} src={logo2}></img>
                                            <a onClick={compraMexico} className='a-bit-opt' target='_blank' href='https://www.elektra.mx/the-bitcoin-enlightenment/p'>{(t('header.btn1'))}</a>
                                        </div>
                                        <div className='div-1'>
                                            <img onClick={IMGcompraInternacional} src={logo1}></img>
                                            <a onClick={compraInternacional} className='a-bit-opt' target='_blank' href='https://thesaifhouse.com/'>{(t('header.btn2'))}</a>
                                            <a onClick={compraInternacional} className='a-bit-opt-small' target='_blank' href='https://academy.saifedean.com/product/the-bitcoin-enlightenment-digital-book/?v=3d26b0b17065'>{(t('header.btn3'))}</a>

                                            {t('donde.btnaudio') === 'EN' && (
                                                <a onClick={compraInternacional} className='a-bit-opt-small' target='_blank' href='https://academy.saifedean.com/product/the-bitcoin-enlightenment-audiobook/?v=0b3b97fa6688'>
                                                    Buy Audiobook
                                                </a>
                                            )}
                                        </div>

                                    </div>
                                </>
                            )}
                        </div>
                        <div class="adquierelo_content_2">
                            <div class="vertical-line"></div>
                        </div>
                        <div class="adquierelo_content_3">
                            <img src={librito}></img>
                        </div>
                    </div>
                </div>
                <div class="landing_bitcoin_donde_cintillo">
                    <h4>{(t('donde.cintillo'))}</h4>
                </div>

            </div>



        </>
    )
}

export default Donde